import { defineMessages } from 'react-intl'

const translations = defineMessages({
  downloadInvoice: {
    defaultMessage: 'Download Invoice',
    id: 'msp.account.order_history.order_detail.download_invoice'
  },
  downloadRefund: {
    defaultMessage: 'Download Credit Note',
    id: 'msp.account.order_history.order_detail.download_refund'
  }
})

export default translations
